(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var selectedVariant = null;

  function renderTargets() {
    var t = [];
    if (document.getElementById('CartDrawer')) t.push({ elId: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    if (document.getElementById('cart-icon-bubble')) t.push({ elId: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    if (document.getElementById('cart-live-region-text')) t.push({ elId: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    var mci = document.getElementById('main-cart-items');
    if (mci) t.push({ elId: 'main-cart-items', section: mci.dataset.id, selector: '.js-contents' });
    var mcf = document.getElementById('main-cart-footer');
    if (mcf) t.push({ elId: 'main-cart-footer', section: mcf.dataset.id, selector: '.js-contents' });
    return t;
  }

  function inject(sections) {
    if (!sections) return;
    renderTargets().forEach(function (t) {
      var html = sections[t.section];
      if (!html) return;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
      var host = document.getElementById(t.elId);
      if (!source || !host) return;
      var dest = host.querySelector(t.selector) || host;
      dest.innerHTML = source.innerHTML;
    });
  }

  function sectionParams() {
    var names = renderTargets().map(function (t) { return t.section; });
    return names.filter(function (v, i) { return names.indexOf(v) === i; });
  }

  function addToCart(variantId) {
    if (!variantId) return Promise.resolve();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionParams(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      inject(data && data.sections);
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        }
      } catch (e) {}
    });
  }

  function modalEl() { return document.getElementById('UpsellModal'); }

  function openModal(title, image, variants) {
    var modal = modalEl();
    if (!modal) return;
    selectedVariant = null;
    modal.querySelector('.upsell-modal__name').textContent = title;
    var img = modal.querySelector('.upsell-modal__img');
    if (image) { img.src = image; img.style.display = ''; } else { img.style.display = 'none'; }
    var sizes = modal.querySelector('.js-upsell-sizes');
    sizes.innerHTML = '';
    var firstAvailable = null;
    variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'upsell-modal__size';
      b.textContent = v.title;
      b.setAttribute('data-variant-id', v.id);
      if (!v.available) { b.disabled = true; b.classList.add('is-soldout'); }
      else if (!firstAvailable) { firstAvailable = b; }
      sizes.appendChild(b);
    });
    var addBtn = modal.querySelector('.js-upsell-modal-add');
    if (firstAvailable) {
      // default-select the first available size
      firstAvailable.classList.add('is-selected');
      selectedVariant = parseInt(firstAvailable.getAttribute('data-variant-id'), 10);
      addBtn.disabled = false;
    } else {
      addBtn.disabled = true;
    }
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
  }

  function closeModal() {
    var modal = modalEl();
    if (!modal) return;
    modal.classList.remove('is-open');
    selectedVariant = null;
    setTimeout(function () { if (modal) modal.hidden = true; }, 250);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var addCard = t.closest('.js-upsell-add');
    if (addCard) {
      if (busy) return;
      var variants = [];
      try { variants = JSON.parse(addCard.getAttribute('data-variants') || '[]'); } catch (err) {}
      var available = variants.filter(function (v) { return v.available; });
      if (variants.length <= 1) {
        // truly single-variant product (no sizes) — add directly
        var only = available[0] || variants[0];
        if (only) {
          busy = true; addCard.disabled = true;
          addToCart(only.id).catch(function () {}).then(function () { busy = false; addCard.disabled = false; });
        }
      } else {
        // has sizes — always show the size picker
        openModal(addCard.getAttribute('data-product-title') || '', addCard.getAttribute('data-product-image') || '', variants);
      }
      return;
    }

    var sizeBtn = t.closest('.upsell-modal__size');
    if (sizeBtn && !sizeBtn.disabled) {
      var modal = modalEl();
      modal.querySelectorAll('.upsell-modal__size').forEach(function (b) { b.classList.remove('is-selected'); });
      sizeBtn.classList.add('is-selected');
      selectedVariant = parseInt(sizeBtn.getAttribute('data-variant-id'), 10);
      modal.querySelector('.js-upsell-modal-add').disabled = false;
      return;
    }

    var modalAdd = t.closest('.js-upsell-modal-add');
    if (modalAdd) {
      if (busy || !selectedVariant) return;
      busy = true; modalAdd.disabled = true;
      addToCart(selectedVariant).catch(function () {}).then(function () { busy = false; closeModal(); });
      return;
    }

    if (t.closest('.js-upsell-close')) { closeModal(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
